export default function WhatsAppFloat() {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-50">
      {/* Mobile bottom bar */}
      <div className="md:hidden bg-gradient-to-t from-background-50 via-background-50/95 to-transparent pt-4 pb-4 px-4">
        <div className="flex items-center gap-3 max-w-md mx-auto">
          <a
            href="tel:+34951120770"
            className="flex-1 flex items-center justify-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm min-h-[48px] px-5 rounded-full shadow-lg shadow-primary-500/25 transition-all active:scale-[0.97] whitespace-nowrap cursor-pointer"
          >
            <span className="w-5 h-5 flex items-center justify-center"><i className="ri-phone-fill text-base"></i></span>
            Llamar
          </a>
          <a
            href="https://wa.me/34627213347"
            target="_blank"
            rel="noopener noreferrer"
            className="flex-1 flex items-center justify-center gap-2 bg-[#25D366] hover:bg-[#1faa52] text-white font-semibold text-sm min-h-[48px] px-5 rounded-full shadow-lg shadow-[#25D366]/25 transition-all active:scale-[0.97] whitespace-nowrap cursor-pointer animate-pulse"
          >
            <span className="w-5 h-5 flex items-center justify-center"><i className="ri-whatsapp-fill text-base"></i></span>
            WhatsApp
          </a>
        </div>
      </div>

      {/* Desktop floating WhatsApp */}
      <div className="hidden md:block fixed bottom-6 right-6 z-50">
        <a
          href="https://wa.me/34627213347"
          target="_blank"
          rel="noopener noreferrer"
          className="w-14 h-14 flex items-center justify-center bg-[#25D366] hover:bg-[#1faa52] text-white rounded-full shadow-xl shadow-[#25D366]/30 transition-all hover:scale-110 cursor-pointer animate-pulse"
          aria-label="WhatsApp"
        >
          <span className="w-8 h-8 flex items-center justify-center"><i className="ri-whatsapp-fill text-2xl"></i></span>
        </a>
      </div>
    </div>
  );
}